import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesPacks } from "../../constants";

export const requestTogglePackActive = async ({
  packId,
  isActive
}: {
  packId: string;
  isActive: boolean;
}): Promise<void> => {
  return await instance.put(
    buildUrl(ApiRoutesPacks.PackActive, packId, String(isActive))
  );
};
